<template>
  <div class="notice-box">
    <el-dialog title="消息" :visible.sync="dialogVisible" width="70rem" :close-on-click-modal="false">
      <div class="button-box">
          <el-input style="width: 20rem;" clearable @clear="search" placeholder="请输入名称" v-model="page.title" @keydown.enter.native="search" suffix-icon="el-icon-search"></el-input>
          <el-button type="primary" @click="readAll">一键读取</el-button>
        </div>
      <div class="box-content">
        <el-card class="box-card" v-for="item in dataInfo" :key="'A' + item.type + item.id">
          <div slot="header" style="display: flex;justify-content: space-between">
            <div class="softwareHeader">
              <el-badge :is-dot="item.isRead == 1">
              </el-badge>
              <span style="margin-left: 1rem;">{{ item.title }}</span>
            </div>
            <el-button :class="{'active-icon':item.isAn}" @click="read(item)" style=" padding: 3px 0;transition: all 0.3s;"
              type="text">
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
          <div>
            <div style="display: flex;justify-content: space-between;align-items: center">
              <div class="updateSoftware">
                <span>你有一条新的消息！</span>
              </div>
              <span class="createTime">{{ item.createTime }}</span>
            </div>
            <div v-if="item.isAn" v-html="item.content"
              style="white-space:pre-line;width: 100%;display: inline-block;margin-top: 1rem"></div>
          </div>
        </el-card>
        <NoData v-if="dataInfo.length === 0"></NoData>
      </div>
      <div class="page-box" v-if="dataInfo.length > 0">
        <el-pagination background @current-change="handleCurrentChange" :current-page.sync="page.current"
          :page-size="page.size" layout="total, prev, pager, next" :total="page.total">
        </el-pagination>
      </div>
    </el-dialog>
    <inform @view_msg="viewMsg"></inform>
  </div>
</template>

<script>
import { PageQueryMyMessageList, ReadMessage, GetNotReadMessageCount } from "@/api/common/messages";
import Inform from './Inform.vue';
import Utils from "@/assets/js/Utils";
export default {
  name: "announcement",
  components: {Inform },
  data() {
    return {
      dataInfo: [],
      dialogVisible: false,
      page: {
        current: 1,
        size: 10,
        total: 0,
        title:''
      }
    };
  },
  created() {
    this.getNotReadMessageCount();
    Utils.$on('notification_message',(e)=>{
      this.getNotReadMessageCount();
      this.$store.commit('notice/changeNoticeVisiable',true);
      this.$store.commit('notice/changeMsgContent',e);
      setTimeout(()=>{
        this.$store.commit('notice/changeNoticeVisiable',false);
      },10000)
    });
  },
  computed: {
    messageCount() {
      return this.$store.state.notice.messageCount;
    },
  },
  methods: {
    /**查看消息 */
    viewMsg(){
      let msgContent=this.$store.state.notice.msgContent;
      this.dialogVisible=true;
      this.$store.commit('notice/changeNoticeVisiable',false);
      this.toGetMessage().then(()=>{
        let el=this.dataInfo.find(item=>item.id==msgContent.id);
        if(el){
          this.read(el);
        }
      });
    },
    /**模糊搜索 */
    search(){
      this.page.current=1;
      this.toGetMessage();
    },
     /**一键读取所以未读公告 */
     readAll(){
      let params = {
          "allRead": true,
          "appCode": process.env.VUE_APP_APP_CODE,
          "messageIds": []
        };
      ReadMessage(params).then(res => {
          if (res.code == 200) {
            this.toGetMessage();
            this.getNotReadMessageCount();
          }
        });
    },
    toGetMessage() {
      return new Promise(resolve=>{
        let params = {
        "current": this.page.current,
        "messageType": [1, 2],
        "isRead": 1,
        "size": this.page.size,
        "title": this.page.title
      };
      PageQueryMyMessageList(params).then(res => {
        if (res.code === 200) {
          let data=res.data.records;
          data.forEach(item=>{
            item.isAn=false;
          })
          this.dataInfo = data;
          this.page.total = res.data.total;
          resolve();
        }
      })
      })
    },
    getNotReadMessageCount() {
      GetNotReadMessageCount('2').then(res => {
        if (res.code === 200) {
          this.$store.commit('notice/changeMsgNum', res.data);
        }
      })
    },
    handleCurrentChange(e) {
      this.page.current = e;
      this.toGetMessage();
    },
    read(value) {
      if(value.isAn===undefined){
        this.$set(value, "isAn", false);
      }
      value.isAn=!value.isAn;
      if (value.isRead === 1) { //未读
        let params = {
          "allRead": true,
          "appCode": process.env.VUE_APP_APP_CODE,
          "messageIds": [value.id]
        }
        ReadMessage(params).then(res => {
          if (res.code == 200) {
            this.getNotReadMessageCount();
            value.isRead = 0;
          }
        });
      } 
    }
  }
};
</script>

<style lang="less" scoped>
.active-icon{
  transform: rotate(90deg);
}
.notice-box{
  color: #334681;
}
/deep/.el-dialog__body {
  overflow-y: auto;
  background-color: #e9f1fa;
  .box-content {
    height: 50rem;
    overflow: auto;
  }

  .page-box {
    margin-top: 2rem;
  }

  .el-card {
    margin-bottom: 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    .el-card__header {
      padding: 1rem 2rem;
      color: #04417e;
      font-size: 14px;

      .softwareHeader {
        display: flex;
        align-items: center;

        .softwareImg {
          display: inline-block;
          height: 3.4rem;
          width: 3.4rem;
          border: solid 1px #d4e6fc;
          border-radius: 50%;
          line-height: 3.2rem;

          img {
            width: 2.6rem;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

.updateSoftware {
  span {
    color: #000000;
    font-size: 16px;
    margin-right: 1rem;
  }

  /deep/.el-button {
    border: solid 1px #d4e6fc;
    background-color: #e6f1ff;
    color: #0074fd;
  }
}
/deep/.el-card__header{
  position: relative;
}
.createTime {
  color: #555555;
  font-size: 12px;
  display: inline-block;
}

/deep/.el-card__body {
  text-align: left !important;
}

/deep/.el-badge {
  // margin-right: 14px !important;
  position: absolute;
  left: 1rem;
  top: 1.5rem;
  .al-gonggao {
    font-size: 2.1rem;
    cursor: pointer;
  }
}
.page-box{
  display: flex;
  justify-content: center;
}
/deep/.el-dialog{
  border-radius: 1rem;
  overflow: hidden;
}
.button-box{
  width: 100%;
  text-align: right;
  display: flex;
  margin-bottom: 20px;
  &> :nth-child(2){
    margin-left: 10px;
  }
}
@media screen and (max-width: 750px) {
    /deep/.el-dialog{
      width: 100% !important;
    }
}
</style>
